const columns = [{
  slots: {
    title: '投保时间'
  },
  dataIndex: 'createAt',
  key: 'createAt',
  align: 'center'
}, {
  slots: {
    title: '保单号'
  },
  dataIndex: 'policyNo',
  key: 'policyNo',
  align: 'center'
}, {
  slots: {
    title: '产品名称'
  },
  dataIndex: 'customerInsuranceName',
  key: 'customerInsuranceName',
  align: 'center'
}, {
  slots: {
    title: '保单来源'
  },
  dataIndex: 'appName',
  key: 'appName',
  align: 'center'
}, {
  slots: {
    title: '承保单位'
  },
  dataIndex: 'unitName',
  key: 'unitName',
  align: 'center'
}, {
  slots: {
    title: '保费'
  },
  dataIndex: 'premium',
  key: 'premium',
  align: 'center'
}, {
  slots: {
    title: '城市'
  },
  dataIndex: 'policyMark',
  key: 'policyMark',
  align: 'center'
}, {
  slots: {
    title: '支付状态'
  },
  dataIndex: 'statusName',
  key: 'statusName',
  align: 'center',
  scopedSlots: {
    customRender: 'customText'
  }
}, {
  slots: {
    title: '支付时间'
  },
  dataIndex: 'paymentAt',
  key: 'paymentAt',
  align: 'center',
  scopedSlots: {
    customRender: 'paymentAt'
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 100,
  scopedSlots: {
    customRender: 'operation'
  }
}];
const pagination = {
  showSizeChanger: true,
  showQuickJumper: true,
  total: 0,
  pageSize: 10,
  // 每页条数
  page: 1,
  current: 1,
  showTotal: total => {
    return `共 ${total} 条`;
  },
  onShowSizeChange: (current, size) => {
    pagination.pageSize = size;
  }
};
const statusSelectList = [{
  key: 'PAY_INITIAL_STATUS',
  name: '待支付'
}, {
  key: 'PAY_SUCCESS',
  name: '支付成功'
}, {
  key: 'PAY_TOBE_PAID',
  name: '支付中'
}];
export { columns, pagination, statusSelectList };